<template>
  <el-dialog title="收款方" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center
             :close-on-click-modal="false" :append-to-body="true"
  >

    <el-form :model="form" ref="form1" :rules="rules">
      <!--<el-row>-->
        <!--<el-col :span="24">-->
          <!--<el-alert-->
            <!--title="修改信息后会同步更新到已提交单据的收款信息"-->
            <!--type="info"-->
            <!--:closable="false"-->
            <!--show-icon>-->
          <!--</el-alert>-->
        <!--</el-col>-->
      <!--</el-row>-->
      <el-row>
        <el-col :span="24">
          <el-form-item label="账户类型" :label-width="formLabelWidth" prop="isperson">
            <div>
              <el-radio v-model="form.isperson" label="1" border @change="selectIsPerson" :disabled="isReadOnly">个人账户
              </el-radio>
              <el-radio v-model="form.isperson" label="0" border @change="selectIsPerson" :disabled="isReadOnly">对公账户
              </el-radio>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="inputName" :label-width="formLabelWidth" prop="deptname">
            <el-input v-model="form.deptname" auto-complete="off" :required="true" :disabled="isReadOnly"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!--<el-row>-->
        <!--<el-col :span="24">-->
          <!--<el-form-item label="户名" :label-width="formLabelWidth" prop="bankname">-->
            <!--<el-input v-model="form.bankname" auto-complete="off" :required="true" :disabled="isReadOnly"></el-input>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
      <!--</el-row>-->
      <el-row>
        <el-col :span="24">
          <el-form-item label="银行账号" :label-width="formLabelWidth" prop="bankaccount">
            <el-input v-model="form.bankaccount" auto-complete="off" :required="true" placeholder="请输入银行卡号"
                      :disabled="isReadOnly" @keyup.native="bankAccountStyle"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="开户行" :label-width="formLabelWidth" prop="bank">
            <el-input v-model="form.bank" auto-complete="off" :required="true" placeholder="请输入开户行"
                      :disabled="isReadOnly"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="联行号"  :label-width="formLabelWidth" >
            <el-input v-model="form.bankname" auto-complete="off" :disabled="isReadOnly" placeholder="请输入联行号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" v-if="!isReadOnly" >确 定</el-button>
    </div>
  </el-dialog>
</template>


<script>
  import {saveData, getDetail, getControlData, getListData} from '@/api/pay/payaccount';
  export default {
    name: "PayAccountEdit",
    data() {

      return {
        formLabelWidth: '120px',
        dialogFormVisible: false,
        loading: false,
        bankArray: [],
        inputName: '单位名称',//动态改变（个人名称、单位名称）
        isReadOnly: false,
        form: {  //表单数据
          unitguid: '',//唯一编码
          uname: '',//添加人（当前登录人）
          uguid: '',//添加人uguid(当前登录人uguid)
          isperson: '',//是否个人
          deptname: '',//单位名称
          bankname: '',//联行号
          bankaccount: '',//银行账号
          bank: '',//开户行
        },
        rules: {////////定义正则验证字段。
          bankaccount: [
            {required: true, message: '请填写银行账号', trigger: 'blur'},
          ],
          bank: [
            {required: true, message: '请选择开户行', trigger: 'blur'},
          ],
          // bankname: [
          //   {required: true, message: '请填写联行号', trigger: 'blur'},
          // ],
          deptname: [
            {required: true, message: '请输入单位名称/个人姓名', trigger: 'blur'}
          ]
        },
      }
    },
    methods: {
      //银行卡号格式化
      bankAccountStyle() {
        this.form.bankaccount = this.form.bankaccount.replace(/\D/g, '').replace(/....(?!$)/g, '$& ')
      },

      //初始化表单
      initForm() {
        for (let i in this.form) {
          this.form[i] = ''
        }
        this.form.isperson = '0';
        this.inputName = '单位名称';
        let userInfo = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
        this.form.uname = userInfo.uname;
        this.form.uguid = userInfo.uguid;
        this.isReadOnly = false;
        this.dialogFormVisible = true
      },

      //切换个人/单位时触发
      selectIsPerson() {
        if (this.form.isperson == 0) {
          this.inputName = '单位名称';
        } else if (this.form.isperson == 1) {
          this.inputName = '个人姓名';
        }
      },

      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            //bankaccount
            this.form.bankaccount = this.form.bankaccount.replace(/\s/g, "");

            saveData(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false;
                //刷新列表
                this.$emit('afterSave', this.form);
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
            });
          }
        })
      },

      initData(unitguid) {
        getDetail({unitguid: unitguid}).then(response => {
          this.initRowData(response.data.obj);
        });
      },
      initRowData(formdata) {
        for (let i in this.form) {
          this.form[i] = formdata[i]
        }
        if (this.form.isperson == 0) {
          this.form.isperson = '0'
        } else if (this.form.isperson == 1) {
          this.form.isperson = '1'
        }
        this.isReadOnly = false;
        this.dialogFormVisible = true
      }
    },
    mounted() {
    },
    components: {
    }
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF
  }
</style>



// WEBPACK FOOTER //
// src/components/oa/payform/PayAccountEdit.vue